/** Неразрывный пробел между словами и цифрами внутри сегмента. */
export function bindNumbersToWords(text: string): string {
  return text
    .replace(/(\p{L}|\p{N})\s+(?=\d)/gu, '$1\u00A0')
    .replace(/(?<=\d)\s+(\p{L}|\p{N})/gu, '\u00A0$1');
}

export function splitLabelSegments(label: string): string[] {
  return label.split(/\s+\/\s+/).map((part) => part.trim()).filter(Boolean);
}
